<template>
	<landing-page-template1 />
</template>

<script>
import LandingPageTemplate1 from '@/views/JnsLandingPages/templates/LandingPageTemplate1.vue';

export default {
	name: 'LumLandingPage',
	components: { LandingPageTemplate1 },
};
</script>

<style scoped>

</style>
